import { axiosInstance } from "@/pages/auth/auth.context";

export interface ManualNotificationRequest {
  notificationType: "EMAIL" | "SMS";
  notificationCategory:
    | "WELCOME"
    | "WELCOME_USER_ADMIN"
    | "EVENT_CREATED"
    | "EVENT_CANCELLED"
    | "EVENT_REMINDER"
    | "ALERT"
    | "ANNOUNCEMENT"
    | "NEW_BID_RECEIVED"
    | "NEW_BID_RECEIVED_CLIENT"
    | "PASSWORD_RESET"
    | "EVENT_POSITION_SIGNUP"
    | "EVENT_POSITION_CANCELLATION"
    | "UPCOMING_EVENT_HAS_OPENINGS";
  recipientType: "USER" | "CLIENT";
  recipientId: string;
  metadata?: Record<string, unknown>;
  additionalData?: Record<string, string | number | boolean>;
  customMessage?: string;
  customSubject?: string;
}

export interface ManualNotificationResponse {
  success: boolean;
  message: string;
  recipientId?: string;
  recipientType?: string;
  notificationType?: string;
}

export const notificationService = {
  async sendManualNotification(
    request: ManualNotificationRequest,
  ): Promise<ManualNotificationResponse> {
    const response = await axiosInstance.post(
      "notifications/manual/send",
      request,
    );
    return response.data;
  },

  async sendWelcomeEmail(userId: string): Promise<ManualNotificationResponse> {
    return this.sendManualNotification({
      notificationType: "EMAIL",
      notificationCategory: "WELCOME",
      recipientType: "USER",
      recipientId: userId,
    });
  },

  async sendEventOpeningNotification(
    eventId: string,
  ): Promise<ManualNotificationResponse> {
    return this.sendManualNotification({
      notificationType: "EMAIL",
      notificationCategory: "UPCOMING_EVENT_HAS_OPENINGS",
      recipientType: "USER",
      recipientId: "", // Not needed for this notification type as it goes to all active users
      metadata: {
        eventId: eventId,
      },
    });
  },
};
